import { defineStore } from 'pinia'
import dashboardApi from '@/helpers/dashboardApi'

interface TrackStore {
  tracksCount: number | null,
  tracks: Track[] | null,
}

export const useTracksStore = defineStore('tracks', {
  state: () => ({
    tracksCount: null,
    tracks: null,
  }) as TrackStore,

  actions: {
    async getTracksCount() {
      const { data } = await dashboardApi.get('api/me/release_tracks', {
        params: {
          pagination: true,
          perPage: 0,
        },
      })

      this.tracksCount = data['hydra:totalItems']
    },

    async getTracksWithoutWorks(releaseId: number) {
      const { data } = await dashboardApi.get('api/me/release_tracks', {
        params: {
          'release.id': releaseId,
          'exists[musicWork]': false,
        },
      })

      this.tracks = data['hydra:member'].sort((a: Track, b: Track) => a.trackNumber - b.trackNumber)
    },

    removeTrack(trackId: number) {
      const tracks = this.tracks?.filter(({ id }) => id !== trackId)

      if (tracks) {
        this.$patch({ tracks })
      }
    },
  },
})
